<template>
  <MainLayout></MainLayout>
</template>

<script>
// eslint-disable-next-line import/no-useless-path-segments
import MainLayout from '../src/layout/MainLayout.vue'

export default {
  name: 'App',
  components: {
    MainLayout,
  },
}
</script>
